import { useEffect } from 'react';

import { generatePath, useNavigate, useSearchParams } from 'react-router-dom';

import routesPath from '@/shared/constants/routesPath';

// Manages search parameters
function useSearchParamsManager({ defaultOrderCriteria }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  // Helper function to update search parameters
  const updateSearchParams = (params) => {
    const newSearchParams = new URLSearchParams(searchParams);
    Object.entries(params).forEach(([key, value]) => {
      newSearchParams.set(key, value);
    });
    setSearchParams(newSearchParams);
  };

  // side effect to redirect to the live scoring page
  // if uuid param exists in the URL for back-compatibility
  const uuid = searchParams.get('uuid');
  useEffect(() => {
    if (uuid) {
      navigate(generatePath(routesPath.LIVESCORING, { uuid }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    query: searchParams.get('q') || '',
    orderCriteria: {
      order: searchParams.get('order') || defaultOrderCriteria.order,
      sort: searchParams.get('sort') || defaultOrderCriteria.sort,
    },
    updateSearchParams,
  };
}

export default useSearchParamsManager;
